import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const MIRAMARDEVELOPMENTPROJECT_LAYER_ID = 'miramarDevelopmentProjectLayer';

export const CATEGORY_COLORS = {
  'Development Project': [237, 100, 90],
};

const layerConfig = {
  title: 'Miramar Development Projects',
};

function MiramarDevelopmentProjectLayer() {
  const dispatch = useDispatch();
  const { miramarDevelopmentProjectLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, miramarDevelopmentProjectLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (miramarDevelopmentProjectLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: MIRAMARDEVELOPMENTPROJECT_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: miramarDevelopmentProjectLayer.visible,
      opacity: miramarDevelopmentProjectLayer.opacity,

      getFillColor: [237, 100, 90],
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: MIRAMARDEVELOPMENTPROJECT_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['Project_Name', 'Project_Status'],
            }),
          };
        }
      },
    });
  }
}

export default MiramarDevelopmentProjectLayer;
